<template>
    <v-flex xl12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <h3>Editar notícia</h3>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container fluid grid-list-lg>
                        <v-layout row wrap>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="register.title"
                                        :rules="nameRules"
                                        label="Título da notícia"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="register.seo_description"
                                        :rules="nameRules"
                                        label="Descrição da notícia (SEO)"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl12 lg12 md6 sm12 xs12>
                                <label>Bibliografia</label>
                                <ckeditor id="editor1" v-model="content" required></ckeditor>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-btn btn dark flat @click.native="onUpload" :disabled="!valid"
                                       class="primary" style="margin: 0;">
                                    Imagem de capa
                                    <v-icon right dark>cloud_upload</v-icon>
                                </v-btn>
                                <p style="font-size: 10px">Arquivos suportados: JPEG, JPG, PNG. 1250x457 pixels</p>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12 v-if="register.poster">
                                <h3> Prévia </h3>
                                <v-btn flat @click.prevent="deleteBanner" style="margin: 0;padding: 0" color="black">
                                    <v-icon color="red">delete</v-icon>
                                    Excluir
                                </v-btn>
                                <br/>
                                <img style="max-width: 700px;max-height: 300px;padding: 2px;border: 1px solid #cccccc;" :src="(!register.poster)? banner_default : register.poster">
                            </v-flex>
                            <input style="display: none" type="file" :multiple="true" ref="fileInput" :accept="'.jpg,.jpeg,.png'" @change="onFileChange">

                        </v-layout>
                    </v-container>
                    <v-btn flat class="primary" @click="submit">Salvar</v-btn>
                    <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    import Ckeditor from "../../components/Ckeditor";

    export default {
        name: 'news-add',
        components: {Ckeditor},
        data: () => ({
            register: JSON.parse(localStorage.getItem('register')),
            poster_original: '',
            select: false,
            error: false,
            success: false,
            banner: {},
            content: '',
            messages: '',
            banner_default: '/img/no-image.png',
            valid: true,
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ]
        }),
        methods: {
            deleteBanner: function () {
                var self = this
                if (self.poster_original !== ''){
                    self.register.poster = self.poster_original
                    self.banner = ''
                    self.poster_original = ''
                    self.select = false
                } else {
                    self.register.poster = ''
                    self.banner = ''
                    self.select = false
                }
            },
            onUpload() {
                if (!this.disabled) {
                    this.$refs.fileInput.click()
                }
            },
            onFileChange(e) {
                var self = this
                var files = e.target.files
                var ext = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
                if ((ext === 'jpeg') || (ext === 'jpg') || (ext === 'png')) {
                    self.banner = files[0]
                    this.createImage(self.banner)
                } else {
                    self.error = true
                    self.messages = 'Arquivo não suportado'
                }
            },
            createImage(file) {
                var self = this
                var reader = new FileReader()
                reader.onload = (e) => {
                    self.poster_original = self.register.poster
                    self.register.poster = e.target.result
                    self.select = true
                }
                reader.readAsDataURL(file)
            },
            submit() {
                var self = this
                let form = new FormData()
                this.messages = ''
                if (this.$refs.form.validate()) {
                    this.register.content = this.content
                    self.$store.commit('setLoading', true)
                    form.append('id', this.register.id)
                    form.append('title', this.register.title)
                    form.append('seo_description', this.register.seo_description)
                    form.append('content', this.register.content)
                    form.append('select', this.select)
                    if (self.select) {
                        form.append('image', self.banner, self.banner.name)
                    }
                    this.axios.post('/edit-news.json', form, {
                        headers: {
                            'Authorization': this.$store.state.token,
                            'content-type': 'multipart/form-data'
                        }
                    }).then(function (response) {
                        self.$store.commit('setLoading', false)
                        if (response.data.success === true) {
                            self.messages = response.data.messages
                            self.success = true
                            setTimeout(function () {
                                self.$router.push('/news')
                            }, 2000)
                        } else {
                            self.error = true
                            self.messages = response.data.messages
                        }
                    })
                }
            },
            clear() {
                this.$router.push('/news')
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.content  = atob(this.register.content);
            })
        }
    }
</script>
